// Therapies subsection form field enum
export enum TherapiesFormField {
  THERAPIES_THERAPIES = 'medical-background/therapies/therapies',
  THERAPIES_THERAPY_PROVIDER = 'medical-background/therapies/therapy-provider',
  THERAPIES_HOME_EXERCISE_PLAN = 'medical-background/therapies/home-exercise-plan',
  THERAPIES_HOME_EXERCISE_DURATION = 'medical-background/therapies/home-exercise-duration',
  THERAPIES_HOME_EXERCISE_FREQUENCY = 'medical-background/therapies/home-exercise-frequency'
}
